import { render, staticRenderFns } from "./AvatarGroupItem.vue?vue&type=template&id=c7652434&scoped=true&"
import script from "./AvatarGroupItem.vue?vue&type=script&lang=js&"
export * from "./AvatarGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGroupItem.vue?vue&type=style&index=0&id=c7652434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7652434",
  null
  
)

export default component.exports